<template>
  <div class="modal notification-modal" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true"
       role="dialog"
       style="display:block; background-color:rgba(255, 255, 255, 0.6);">
    <div class="modal-dialog-centered modal-base">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">한건 업로드</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <div class="modal-body">
            <div class="info-div" style="overflow-x:auto;">

              <table class="info-table">
                  <colgroup>
                    <col width="40%">
                    <col width="60%">
                  </colgroup>
                  <tr>

                    <td>지역</td>
                    <td class="w-50">
                      <input class="form-control" :placeholder="'ex)서울 혹은 서울,경기'" v-model="selectedRegion"
                              @change="changeFormValue($event,'region')">
                    </td>
                  </tr>
                  <tr>
                    <td>사업자번호</td>
                    <td class="w-50">
                      <input class="form-control" :placeholder="'ex)1111111111,2222222222'" v-model="selectedCompany"
                             @change="changeFormValue($event,'company')">
                    </td>
                  </tr>
                <tr>
                  <td>시작일 <label style="color: red">*</label></td>
                  <td>
                    <input name="selectStartDay" id="selectStartDay" class="form-control" type="date"
                           @change="changeFormValue($event,'start')" v-model="formData.startDay" min="2000-01-01"
                           max="2999-12-31"/>
                  </td>
                </tr>

                <tr>
                  <td>종료일  <label style="color: red">*</label></td>
                  <td>
                    <div class="'col mb-3'">
                      <input name="selectEndDay" id="selectEndDay" class="form-control" type="date" @change="changeFormValue($event,'end')"
                             v-model="formData.endDay" min="2000-01-01" max="2999-12-31"/>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td> 사업자 구분 </td>
                  <td>
                    <select class="form-select w-150" v-model="carType"
                            @change="changeFormValue($event, 'carType')">
                      <option value="">전체</option>
                      <option value="21">법인</option>
                      <option value="22">개인</option>
                    </select>
                  </td>
                </tr>
                  <tr>
                    <td>차량번호</td>
                    <td class="w-50">
                      <div class="d-flex align-items-center gap-2">
                        <label class="mb-0">
                          부분일치
                          <input type="checkbox" id="carNumLike" @change="onChangeCarLike($event)">
                        </label>
                        <input class="form-control"
                               :placeholder="'ex)서울99가9999 미입력시 전체'"
                               v-model="selectedCarNum"
                               list="carNumDatalist"
                               @change="changeFormValue($event,'carNum')">
                      </div>
                    </td>
<!--                      <td class="w-50">-->
<!--                        부분일치 <input type="checkbox" @change="changeFormValue($event,'carNum')">-->
<!--                        <input class="form-control" :placeholder="'ex)서울99가9999 미입력시 전체'" v-model="selectedCarNum"-->
<!--                               list="carNumDatalist" @change="changeFormValue($event,'carNum')">-->
<!--                    </td>-->
                  </tr>
                <tr>
                  <td>추출 타입 <label style="color: red">*</label></td>
                  <td style="padding-left: 30px">
                    <select name="reqType" id="reqType" :value="reqType" class="form-control" @change="selectedType($event)" >
                      <option v-for="extractionType in typeList" :value="extractionType" :key="extractionType">{{ extractionType }}</option>
                    </select>
                  </td>
                </tr>
                </table>

                <table class="info-table">

                    <colgroup>
                        <col width="20%">
                        <col width="50%">
                        <col width="*">
                    </colgroup>
                    <tbody>

                        <tr>
                          <th>성공여부</th>
                          <th>원인</th>
                          <th>시간</th>
                        </tr>
                        <tr>
                          <td>{{resultData.result }}</td>
                          <td>{{resultData.status }}</td>
                          <td>{{resultData.uploadDate }}</td>
                          <td hidden="true">{{resultData.id }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="extraction">추출하기</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
import {useStore} from "vuex";
import axios from "@/composables/Axios";
import tachoEntity from "@/entity/TachoEntity";
import Entity from "@/entity/OperationEntity";
import dayjs from "dayjs";
import CarNumWithSearchInput from "@/components/tacho/searchbar/CarNumWithSearchInput.vue";
import {changeFormat, datePlus1day} from "@/components/tacho/common/CommonFunc";
const url = tachoEntity.baseUrl;
const ezlUrl =  tachoEntity.tachodUrl;
const store = useStore();
const carType = ref("");
const operationUrl = store.state['api'].operationUrl;
const entity = new Entity.organizationHeaders(store.state.sign['userInfo'].userId);
const header = entity.get();
const formData = new tachoEntity.drivingSearchDto()
const regionList = ref([]);
const selectedRegion = ref();
const selectedCompany = ref();
const setLoading = (value) => store.commit('setLoading', value)
const companyList = ref([]);
const typeList = ref([]);
const reqType = ref("");
const selectedType = (e) => {
  reqType.value = e.target.value;
}
const props = defineProps({
  regionList: Object,
})
const downloadTF = ref(true);
const fileName = ref("");
const resultData = ref({status:"",result:"",uploadDate:"",id:-1});
const selectedCarType = ref("전체");
const carNumList = ref();
const selectedCarNum = ref();
const carNumLike = ref(false);

const emit = defineEmits(['close', 'refreash']);
let queryParam = new tachoEntity.vehicleQueryParam();
onMounted(async () =>{
  formData.startDate = changeFormat(formData.startDate,'YYYY-MM-DDTHH:mm:ss');
  formData.startDay = changeFormat(formData.startDate,'YYYY-MM-DD');

  selectStartDay.value =  changeFormat( formData.startDay, 'YYYY-MM-DD');

  let end = datePlus1day(formData.startDay);
  selectEndDay.min = formData.startDay;
  selectEndDay.value =  changeFormat( end, 'YYYY-MM-DD');

  formData.endDate = changeFormat(end,'YYYY-MM-DDTHH:mm:ss');
  formData.endDay = changeFormat(end,'YYYY-MM-DD');

  const typeres = await axios.$get(`${ezlUrl}data-extraction/type`, {}, header);
  typeList.value = typeres.data;
  reqType.value = typeList.value[0];

})
const changeFormValue = async (event, name) => {
  switch (name) {
    case "region": {
      if (textVali('text',selectedRegion.value)){
        formData.region = selectedRegion.value;
      }else{
        alert('올바른 지역을 입력하세요 (한글과 쉼표만 입력가능합니다.)');
        return;
      }
      break
    }
    case "company":{
      if (textVali('number',selectedCompany.value)){
        formData.officeId = selectedCompany.value;
      }else{
        alert('올바른 사업자번호를 입력하세요 (숫자와 쉼표만 입력가능합니다.)');
        return;
      }
      break;
    }
    case "carNum":{
      if (textVali('car',selectedCarNum.value)){
        formData.carNum = selectedCarNum.value;
      }else{
        alert('올바른 차량번호를 입력하세요 (숫자와 쉼표만 입력가능합니다.)');
        return;
      }
      break;
    }
    case "start": {
      let end = datePlus1day(formData.startDay);
      selectEndDay.min = formData.startDay;
      selectEndDay.value =  changeFormat( end, 'YYYY-MM-DD');

      formData.endDate = changeFormat(end,'YYYY-MM-DDTHH:mm:ss');
      formData.endDay = changeFormat(end,'YYYY-MM-DD');

      break;
    }
    case "end": {
      selectEndDay.value = event.target.value;
      break;
    }
    case "carType":{
      selectedCarType.value = carType.value;
      break;
    }
  }

}

const onChangeCarLike = (event) => {
  carNumLike.value = event.target.checked;
}
const textVali = (type,target) => {
  let res = true;
  if (type == "text"){
    const pattern = /^[가-힣,]+$/;
    res = pattern.test(target);
  }

  else if (type == "number"){
    const pattern = /^[0-9,]+$/;
    res = pattern.test(target);
  }
  else if (type == "car"){
    const pattern = /^[가-힣0-9,]+$/;
    res = pattern.test(target);
  }

  return res;
}
const extraction = async () => {
  //업로드
  await validate();
}

const validate = async () => {

    try {
    let header = entity.get();

    let queryParam = {
      office_id: formData.officeId,
      car_num: formData.carNum,
      start_date: changeFormat(formData.startDay,"YYYYMMDD"),
      end_date:  changeFormat(formData.endDay,"YYYYMMDD"),
      user_id : header.user_id,
      req_type: reqType.value,
      city_name : selectedRegion.value,
      etc:'',
      car_num_like:carNumLike.value
    }
    if(!queryParam.req_type) {
      alert('추출타입을 입력하세요');
      return;
    }
    if(!queryParam.start_date) {
      alert('시작일을 선택하세요');
      return;
    }
    if(selectedCarType.value != "전체"){
      queryParam.car_type = selectedCarType.value;
    }

    const res = await axios.$post(`${ezlUrl}data-extraction/request`, queryParam, {headers: header});

    axios.$get(`${ezlUrl}data-extraction/execute-request/${res.data.req_id}`, {
        responseType: 'blob'
    }, header);

    resultData.value.result = "성공";
    resultData.value.status = "";
    downloadTF.value = false;
    emit('close');

  } catch (error) {
      resultData.value.result = "실패"
      downloadTF.value = true;
      resultData.value.status = error.response.data.message;
  }
}

</script>

<style scoped>
.dropdown-wrapper {
  position: relative;
  width: 100%;
}
.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background: white;
  z-index: 1000;
  padding: 0;
  margin: 0;
  list-style: none;
}
.dropdown-list li {
  padding: 8px 12px;
  cursor: pointer;
}
.dropdown-list li:hover {
  background-color: #f1f1f1;
}

</style>
